import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false,
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        bg-terracotta hover:bg-terracotta-hover text-white font-bold py-4 px-8 rounded-xl
        shadow-lg shadow-terracotta/20 transition-colors duration-300
        text-lg md:text-xl flex items-center justify-center gap-2
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} {...props} data-id="element-1">
      {children}
    </motion.button>;
}